var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCountdown)?_c('div',{staticClass:"countdown"},[_vm._v(" "+_vm._s(_vm.countdown)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }